import { CountrySelectController } from './country-select.controller';
import { Bindings } from 'booking_app/types';

export class CountrySelectComponent {
  bindings: any;
  controller: any;
  template: string;

  constructor() {
    this.bindings = {
      value: Bindings.ONE_WAY,
      formName: Bindings.ONE_WAY,
      onUpdate: Bindings.EXPRESSION,
      secondaryPassenger: Bindings.ONE_WAY,
    };
    this.controller = CountrySelectController;
    this.template = `
    <input-select
      value-formatter="$ctrl.displayOptions"
      selected-value="$ctrl.internalValue"
      placeholder="'Country'"
      on-update="$ctrl.onUpdateInternalValue(value)"
      form-name="$ctrl.formName"
      options="$ctrl.options"
      search-enabled="true"
      trigger-update-on-init="true"
    ></input-select>
    `;
  }
}

angular.module("BookingApp").component("countrySelectComponent", new CountrySelectComponent());
